<template>
  <div class="w-full">
    <vs-col>
      <vs-row>
        <headcount-indicator
          :refresh="refresh"
          class="darkModeCard cardHeigth mb-6"
          style="font-weight: bold; font-size: 1vm !important"
          @click="openHeadcount"
        />
      </vs-row>
      <vs-row>
        <direct-indicator
          :refresh="refresh"
          class="darkModeCard cardHeigth mb-6"
          style="font-weight: bold; font-size: 1vm !important"
          @click="openDirect"
        />
      </vs-row>
      <vs-row>
        <indirect-indicator
          :refresh="refresh"
          class="darkModeCard cardHeigth mb-6"
          style="font-weight: bold; font-size: 1vm !important"
          @click="openIndirect"
        />
      </vs-row>
      <vs-row>
        <complementary-indicator
          :refresh="refresh"
          class="darkModeCard cardHeigth mb-6"
          style="font-weight: bold; font-size: 1vm !important"
          @click="openComplementary"
        />
      </vs-row>
    </vs-col>
  </div>
</template>

<script>
import HeadcountIndicator from '../../charts/HeadcountIndicator.vue'
import DirectIndicator from '../../charts/DirectIndicator.vue'
import IndirectIndicator from '../../charts/IndirectIndicator.vue'
import ComplementaryIndicator from '../../charts/ComplementaryIndicator.vue'

export default {
  components: {
    HeadcountIndicator,
    DirectIndicator,
    IndirectIndicator,
    ComplementaryIndicator,
  },
  data() {
    return {}
  },
  props: ['data', 'refresh'],
  methods: {
    openHeadcount() {
      this.$emit('click', 'headcount')
    },
    openDirect() {
      this.$emit('click', 'direct')
    },
    openIndirect() {
      this.$emit('click', 'indirect')
    },
    openComplementary() {
      this.$emit('click', 'complementary')
    },
  },
}
</script>

<style>
.card-value {
  font-weight: bold;
}
.cardHeigth {
  height: 10vh !important;
  font-size: 1.4em;
  margin-bottom: 1vh !important;
}
.letrasNegras {
  color: white;
  font-weight: bold;
}
.colorBoxH {
  padding: 9px;
  border-radius: 6px;
  color: rgb(112, 101, 236);
  background: rgba(112, 101, 236, 0.25);
}
.colorBoxD {
  padding: 9px;
  border-radius: 6px;
  color: rgb(27, 200, 117);
  background: rgba(27, 200, 117, 0.25);
}
.colorBoxI {
  padding: 9px;
  border-radius: 6px;
  color: rgb(255, 159, 74);
  background: rgba(255, 159, 74, 0.25);
}
.colorBoxC {
  padding: 9px;
  border-radius: 6px;
  color: rgb(7, 181, 201);
  background: rgba(7, 181, 201, 0.25);
}
</style>